
//TODO Generalize common strings
export const classiEnergetiche: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

/* -------------- */
/* -- LAVAGGIO -- */
/* -------------- */
export const LavatricePosizionamento: string[] = [
    'Da incasso',
    'Libera installazione'
]

export const LavatriceTipologia: string[] = [
    'Caricamento Frontale',
    "Caricamento dall'alto",
]

export const AsciugatricePosizionamento: string[] = [
    'Libera installazione'
]

export const AsciugatriceTipologia: string[] = [
    'Caricamento frontale',
    "Caricamento dall'alto",
]

export const LavasciugaTipologia: string[] = [
    'Caricamento frontale',
    "Caricamento dall'alto",
]

export const LavasciugaPosizionamento: string[] = [
    'Da incasso',
    'Libera installazione'
]

export const LavastovigliePosizionamento: string[] = [
    'Libera installazione',
    'A scomparsa totale',
    'A scomparsa parziale',
    'Sottopiano',
]

/* ------------------- */
/* -- CONSERVAZIONE -- */
/* ------------------- */
export const FrigoriferoTipologia: string[] = [
    'Combinato',
    'Da Tavolo',
    'Doppia Porta',
    'Mini',
    'Monoporta',
    'Portatile',
    'Side By Side',
    'Sottopiano'
]

export const FrigoriferoPosizionamento: string[] = [
    'Da incasso',
    'Libera installazione',
    'Portatile',
    'Sottopiano'
]

export const FrigoriferoNumeroStelle: string[] = [
    '0',
    '1',
    '2',
    '3',
    '4',
]

export const CongelatoreTipologia: string[] = [
    'Congelatore a pozzo',
    'Congelatore verticale'
]

export const CongelatorePosizionamento: string [] = [
    'Da incasso',
    'Libera installazione',
    'Sottopiano'
]

export const CantinettaPosizionamento: string[] = [
    'Da incasso',
    'Libera installazione'
]

/* ----------------------- */
/* -- COMPONENTI CUCINA -- */
/* ----------------------- */
export const PianoCotturaTipologia: string[] = [
    'Elettrico',
    'A Induzione',
    'Gas',
    'Ceramica',
    'Gas + Induzione',
    'Combi'
]

export const PianoCotturaPosizionamento: string[] = [
    'Libera installazione',
    'Da incasso',
    'Superficie Piana'
]

export const PianoCotturaMateriale: string[] = [
    'Di Ghisa',
    'Acciaio inox',
    'Vetro-ceramica',
    'Vetro temperato',
    'Vetro',
    'Ceramica',
    'Smaltato',
]

export const FornoTipologia: string[] = [
    'Forno elettrico',
    'Forno a gas naturale'
]

export const FornoPosizionamento: string[] = [
    'Da incasso',
    'Libera installazione'
]

export const CappeTipologia: string[] = [
    'Cappa Aspirante ad Isola',
    'Integrato a Soffitto',
    'Cappa ad Angolo',
    'Cappa aspirante a Parete',
    'Semintegrato (semincassato)',
    'Downdraft',
    'Cappa sottopensile',
    'A soffitto',
    'Cappa aspirante ad incasso'
]

export const CucinaTipologiaPianoCottura: string[] = [
    'A gas',
    'Elettrico'
]

export const LavelloTipologia: string[] = [
    'Ad incasso',
    'Sottotop',
    'Sopratop',
    'Montato su Piano',
    'incasso/Sottotop',
    'Filotop',
    'Sottopiano'
]

/* ---------------------------- */
/* -- ALTRI ELETTRODOMESTICI -- */
/* ---------------------------- */
export const MicroondePosizionamento: string[] = [
    'Da incasso',
    'Libera installazione',
    'Superificie Piana'
]

export const CondizionatoreTipologia: string[] = [
    'Condizionatore portatile',
    "Condizionatore unità esterna",
    'Condizionatore unità interna',
    'Condizionatore split',
    'Condizionatore monoblocco'
]


export const SiNo: string[] = [
    'Si',
    'No'
]